import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { OPEN_TOFU_MIGRATION_QUEUE_CLEAN } from "./gql";

const useOpenTofuMigrationClearQueue = createDefaultMutationHook(OPEN_TOFU_MIGRATION_QUEUE_CLEAN);

export default useOpenTofuMigrationClearQueue;
